import { RootState } from "src/redux/store";

export const facilityLayoutsStoreSelector = (state: RootState) => state.facilityLayoutsStore;
export const facilityLayoutsSelector = (state: RootState) => state.facilityLayoutsStore.layouts;
